<template>
	<section class="specialization_form">

		<div class="field">
			<label for="field02">Название</label>
			<input type="text" id="field02" v-model="model.name">
		</div>

		<div class="field">
			<label for="field03">Код</label>
			<input type="number" id="field03" v-model="model.code">
		</div>

		<div class="field">
			<label for="field01">Статус</label>
			<select id="field01" v-model="model.status">
				<option value="verified">Верифицированая</option>
				<option value="not_verified">Не верифицированая</option>
			</select>
		</div>

	</section>
</template>
<script>
	export default {
		name: "SpecializationForm",
		props: ['model']
	}
</script>



// WEBPACK FOOTER //
// SpecializationForm.vue?cc2c1f4a